(ns pfo.task.controller (:require
                          [pfo.api :as api  :refer [process-error]]
                          [promesa.core :as p]
                          [pfo.util :as util]
                          [pfo.task.model :as model]
                          [keechma.next.controller :as ctrl]))

(derive :task-links :keechma/controller)
(defmethod ctrl/handle :task-links
  [{:keys [state*] :as ctrl} event {:keys [task-id complete-by]}]
  (case event
    :load (->> (api/ajaxp (str "/task/" task-id "/link/")
                 {:params (util/remove-nil-values {:complete_by complete-by})})
            (p/map
              (fn [links-response]
                (ctrl/transact ctrl
                  (fn [& args]
                    (reset!
                      state* (update-vals (update-keys links-response (fn [key] (util/str->int (name key))))
                               (fn [task-val]
                                 (update-keys task-val #(name %)))))))))
            (process-error))
    :clear (reset! state* nil)
    nil))

(derive :template-shapes :keechma/controller)
(defmethod ctrl/handle :template-shapes
  [{:keys [state*] :as ctrl} event {:keys [family-id task-type order]}]
  (case event
    :load (->> (api/ajaxp (str "/templategroup/shape/")
                 {:params (util/remove-nil-values {:group_id family-id
                                                   :type task-type
                                                   :order order
                                                   :filter_active "active"})})
            (p/map (fn [response] (ctrl/transact ctrl #(reset! state* response))))
            (process-error))
    :clear (reset! state* nil)
    nil))


(derive :template-shape-chart-count :keechma/controller)
(defmethod ctrl/handle :template-shape-chart-count
  [{:keys [state*] :as ctrl} event task-filter-params]
  (case event
    :load (->> (model/template-shape-chart-counts task-filter-params)
            (p/map (fn [response] (ctrl/transact ctrl #(reset! state* response))))
            (process-error))
    :clear (reset! state* nil)
    nil))

(derive :toggle-alert :keechma/controller)
(defmethod ctrl/handle :toggle-alert
  [{:keys [state*] :as ctrl} event {:keys [task-id enabled before-due-days past-due-days on-success]}]
  (case event
    :save (->> (model/toggle-alert task-id enabled before-due-days past-due-days)
               (p/map (fn [response] 
                        (ctrl/transact ctrl #(reset! state* response))
                        (some-> on-success (apply []))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :alert-count :keechma/controller)
(defmethod ctrl/handle :alert-count
  [{:keys [state*] :as ctrl} event {:keys [on-success]}]
  (case event
    :load (->> (model/alert-count)
               (p/map (fn [response]
                        (ctrl/transact ctrl #(reset! state* response))
                        (some-> on-success (apply [response]))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :alert-list :keechma/controller)
(defmethod ctrl/handle :alert-list
  [{:keys [state*] :as ctrl} event {:keys [page order]}]
  (case event
    :load (->> (model/alert-list page order)
               (p/map (fn [response] (ctrl/transact ctrl #(reset! state* response))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :group-independent-tasks :keechma/controller)
(defmethod ctrl/handle :group-independent-tasks
  [{:keys [state*] :as ctrl} event {:keys [task-group-id group-step-indexes on-success on-error errors-atom]}]
  (case event
    :save (->>
             (api/ajaxp (str "/task/group_independent/") 
                        {:method :post
                         :params (util/remove-nil-values {:task_group_id task-group-id
                                                          :group_step_indexes group-step-indexes})})
             (p/map (or on-success (fn [_])))
             (p/error (or on-error (fn [error-response] (throw error-response))))
             (process-error errors-atom))
    :clear (reset! state* nil)
    nil))
